"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTag = createTag;
exports.deleteTag = deleteTag;
exports.editTag = editTag;
exports.mergeTags = mergeTags;
exports.toggleTagCreation = toggleTagCreation;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

function createTag(_x) {
  return _createTag.apply(this, arguments);
}

function _createTag() {
  _createTag = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(tagName) {
    var _yield$axios$put, data;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.put('/settings/tags/create', {
              tagName: tagName
            });

          case 2:
            _yield$axios$put = _context.sent;
            data = _yield$axios$put.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createTag.apply(this, arguments);
}

function editTag(_x2, _x3, _x4, _x5, _x6) {
  return _editTag.apply(this, arguments);
}

function _editTag() {
  _editTag = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(tagId, oldName, newName, page, pageSize) {
    var _yield$axios$post, data;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.post("/settings/tags/".concat(tagId), {
              oldName: oldName,
              newName: newName,
              page: page,
              pageSize: pageSize
            });

          case 2:
            _yield$axios$post = _context2.sent;
            data = _yield$axios$post.data;
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _editTag.apply(this, arguments);
}

function deleteTag(_x7) {
  return _deleteTag.apply(this, arguments);
}

function _deleteTag() {
  _deleteTag = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(tagId) {
    var _yield$axios$delete, data;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.delete("/settings/tags/".concat(tagId), {
              data: {
                csrfToken: (0, _csrfToken.csrfToken)()
              }
            });

          case 2:
            _yield$axios$delete = _context3.sent;
            data = _yield$axios$delete.data;
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _deleteTag.apply(this, arguments);
}

function mergeTags(_x8, _x9) {
  return _mergeTags.apply(this, arguments);
}

function _mergeTags() {
  _mergeTags = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(newName, tagsToMerge) {
    var _yield$axios$post2, data;

    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _axios.default.post("/settings/tags/mergeTags", {
              newName: newName,
              tagsToMerge: tagsToMerge
            });

          case 2:
            _yield$axios$post2 = _context4.sent;
            data = _yield$axios$post2.data;
            return _context4.abrupt("return", data);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _mergeTags.apply(this, arguments);
}

function toggleTagCreation(_x10) {
  return _toggleTagCreation.apply(this, arguments);
}

function _toggleTagCreation() {
  _toggleTagCreation = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(isActive) {
    var _yield$axios$post3, data;

    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _axios.default.post('/settings/tags/toggleTagCreation', {
              isActive: isActive
            });

          case 2:
            _yield$axios$post3 = _context5.sent;
            data = _yield$axios$post3.data;
            return _context5.abrupt("return", data);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _toggleTagCreation.apply(this, arguments);
}